import { Row, TextField, Typography as Paragraph } from 'shared/Houston';

import styled from '@eduzz/houston-styles/styled';

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 0.3fr 0.28fr;
  padding: ${({ theme }) => theme.spacing.xxxs};
  justify-content: center;
  align-items: center;
`;

export const TypographyCenter = styled(Paragraph)`
  justify-self: center;
  color: ${({ theme }) => theme.neutralColor.low.medium};
`;

export const TypographyEnd = styled(Paragraph)`
  justify-self: end;
  color: ${({ theme }) => theme.neutralColor.low.medium};
`;

export const TypographyStart = styled(Paragraph)`
  justify-self: start;
  color: ${({ theme }) => theme.neutralColor.low.medium};
`;

export const Loading = styled(Row)`
  height: calc(100vh - 326px);
  margin-top: 0;
`;

export const List = styled.div`
  display: grid;
  grid-row-gap: ${({ theme }) => theme.spacing.nano};

  grid-template-columns: 100%;
  grid-template-rows: 1fr;
  grid-area: Row;
  justify-content: center;
  align-items: center;
`;

export const Field = styled(TextField)`
  background-color: ${({ theme }) => theme.neutralColor.high.pure};
  margin: ${({ theme }) => `${theme.spacing.xxs} 0`};
`;

export const ContainerPagination = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xxxs};
`;

export const EmptyContainer = styled.div`
  text-align: center;
  height: calc(100vh - 352px);
  width: 100%;
`;
